import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Header } from "../../../components/header";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { useCreateCustomerAddress } from "../hooks";
import { CustomerAddressForm } from "../components";

export const CreateCustomerAddress: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const customerId = searchParams.get("customerId");

  const { form, submit, loading } = useCreateCustomerAddress({
    defaultValues: {
      customerId: customerId ? +customerId : undefined,
      isMain: false,
      active: true,
    },
    onCompleted: () => {
      toast.success("L'adresse a été créée avec succès");
      if (customerId) {
        navigate(`/customer/${customerId}`);
      }
    },
  });

  return (
    <>
      <Header
        title="Adresse"
        subtitle="Créer une nouvelle adresse"
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/customer-addresses`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="card">
          <CardHeader title="Nouvelle adresse" />
          <CustomerAddressForm loading={loading} submit={submit} form={form} />
        </div>
      </div>
    </>
  );
};
